// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mention Autocomplete Popup */
.mention-autocomplete {
  position: absolute;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-height: 280px;
  overflow-y: auto;
  z-index: 1500;
  min-width: 200px;
  padding: 4px 0;
  /* Smooth open animation */
  animation: mentionPopupFadeIn 150ms ease-out;
}

@keyframes mentionPopupFadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Position above input when inside message input container */
.message-input-container .mention-autocomplete {
  bottom: 100%;
  left: 8px;
  top: auto !important;
  margin-bottom: 4px;
}

/* Individual suggestion item */
.mention-suggestion-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.mention-suggestion-item:hover {
  background: #f5f5f5;
}

.mention-suggestion-item.selected {
  background: #e3f2fd;
}

.mention-suggestion-item:focus {
  outline: none;
  background: #e3f2fd;
}

/* Avatar styles */
.mention-suggestion-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 8px;
  object-fit: cover;
  flex-shrink: 0;
}

.mention-suggestion-avatar-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #7e57c2;
  color: white;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}

/* Display name */
.mention-suggestion-name {
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* User ID (shown when different from display name) */
.mention-suggestion-userid {
  font-size: 12px;
  color: #888;
  margin-left: 6px;
  flex-shrink: 0;
  opacity: 0.8;
}

/* Info container for name + optional mxid second line */
.mention-suggestion-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}

.mention-suggestion-top-line {
  display: flex;
  align-items: center;
}

/* Full MXID shown as second line for disambiguation */
.mention-suggestion-mxid {
  font-size: 11px;
  color: #888;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 1px;
}

/* Empty state */
.mention-autocomplete-empty {
  padding: 12px;
  text-align: center;
  color: #999;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/components/MentionAutocomplete/MentionAutocomplete.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,6DAA6D;AAC7D;EACE,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB","sourcesContent":["/* Mention Autocomplete Popup */\n.mention-autocomplete {\n  position: absolute;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  max-height: 280px;\n  overflow-y: auto;\n  z-index: 1500;\n  min-width: 200px;\n  padding: 4px 0;\n  /* Smooth open animation */\n  animation: mentionPopupFadeIn 150ms ease-out;\n}\n\n@keyframes mentionPopupFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Position above input when inside message input container */\n.message-input-container .mention-autocomplete {\n  bottom: 100%;\n  left: 8px;\n  top: auto !important;\n  margin-bottom: 4px;\n}\n\n/* Individual suggestion item */\n.mention-suggestion-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.mention-suggestion-item:hover {\n  background: #f5f5f5;\n}\n\n.mention-suggestion-item.selected {\n  background: #e3f2fd;\n}\n\n.mention-suggestion-item:focus {\n  outline: none;\n  background: #e3f2fd;\n}\n\n/* Avatar styles */\n.mention-suggestion-avatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  margin-right: 8px;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.mention-suggestion-avatar-fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #7e57c2;\n  color: white;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n/* Display name */\n.mention-suggestion-name {\n  font-size: 14px;\n  color: #333;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* User ID (shown when different from display name) */\n.mention-suggestion-userid {\n  font-size: 12px;\n  color: #888;\n  margin-left: 6px;\n  flex-shrink: 0;\n  opacity: 0.8;\n}\n\n/* Info container for name + optional mxid second line */\n.mention-suggestion-info {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1;\n}\n\n.mention-suggestion-top-line {\n  display: flex;\n  align-items: center;\n}\n\n/* Full MXID shown as second line for disambiguation */\n.mention-suggestion-mxid {\n  font-size: 11px;\n  color: #888;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-top: 1px;\n}\n\n/* Empty state */\n.mention-autocomplete-empty {\n  padding: 12px;\n  text-align: center;\n  color: #999;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
